<template>
  <div class="H5Nav">
    <!-- <router-link
      to="/h5/journal"
      tag="div"
      class="item"
      v-if="type === 'journal'"
    >
      <img src="../../../assets/img/h5/item-bookAct.png" alt />
      <p class="act">杂志架</p>
    </router-link>
    <router-link
      to="/h5/journal"
      tag="div"
      class="item"
      v-if="type !== 'journal'"
    >
      <img src="../../../assets/img/h5/item-book.png" alt />
      <p>杂志架</p>
    </router-link> -->
    <router-link
      to="/h5/libraryList"
      tag="div"
      class="item"
      v-if="type === 'library'"
    >
      <!-- <img src="../../../assets/img/h5/item-setAct.png" alt /> -->
      <img src="../../../assets/img/h5/item-bookAct.png" alt />
      <p class="act">杂志库</p>
    </router-link>
    <router-link
      to="/h5/libraryList"
      tag="div"
      class="item"
      v-if="type !== 'library'"
    >
      <!-- <img src="../../../assets/img/h5/item-set.png" alt /> -->
      <img src="../../../assets/img/h5/item-book.png" alt />
      <p>杂志库</p>
    </router-link>
    <router-link to="/h5/my" tag="div" class="item" v-if="type === 'my'">
      <img src="../../../assets/img/h5/item-myAct.png" alt />
      <p class="act">我的</p>
    </router-link>
    <router-link to="/h5/my" tag="div" class="item" v-if="type !== 'my'">
      <img src="../../../assets/img/h5/item-my.png" alt />
      <p>我的</p>
    </router-link>
  </div>
</template>

<script>
// import bg from "@/assets/img/learning/bg.png"; // 关于我们

export default {
  props: {
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // img: {
      //   bg
      // }
    };
  }
};
</script>

<style lang="less">
.H5Nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 56px;
  background: #ffffff;
  box-shadow: 0 -2px 4px 0 rgba(142, 142, 142, 0.06);
  .item {
    text-align: center;
    img {
      width: 21px;
      margin-bottom: 4px;
    }
    p {
      font-size: 10px;
      color: #626466;
      text-align: center;
    }
    .act {
      color: #6c2c66;
    }
  }
}
</style>
